import ListingCards from './ListingCard';

export default ListingCards;
